import React, { memo } from 'react';
import { motion } from 'framer-motion';
export function PainPoints() {
  return <section id="about" className="py-10 sm:py-16 lg:py-24 px-4 sm:px-6 lg:px-8 bg-[#0a0a0a]" data-id="element-82">
      <div className="max-w-3xl mx-auto" data-id="element-83">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="space-y-5 sm:space-y-8 text-base sm:text-lg lg:text-xl text-zinc-300 leading-relaxed font-light" data-id="element-84">
          <p className="first-letter:text-4xl sm:first-letter:text-5xl first-letter:font-serif first-letter:text-[#FFCC00] first-letter:float-left first-letter:mr-2 sm:first-letter:mr-3 first-letter:mt-[-6px] sm:first-letter:mt-[-10px]" data-id="element-85">
            Porque hubo una época en la que Venezuela era futuro.
          </p>

          <p data-id="element-86">
            Y después, casi sin que el mundo lo entendiera —y a veces sin que
            nosotros mismos lo pudiéramos explicar— se convirtió en miedo,
            escasez, exilio, silencio.
          </p>

          <div className="border-l-2 border-[#CF142B] pl-4 sm:pl-6 py-2 my-5 sm:my-8 italic text-zinc-400" data-id="element-87">
            <p className="mb-3 sm:mb-4" data-id="element-88">Y lo peor es esto:</p>
            <p className="font-medium text-zinc-200 text-sm sm:text-base" data-id="element-89">
              Todavía hoy hay gente que dice "eso no fue para tanto"…
            </p>
            <p className="font-medium text-zinc-200 text-sm sm:text-base" data-id="element-90">
              o que "fue culpa de otros"…
            </p>
            <p className="font-medium text-zinc-200 text-sm sm:text-base" data-id="element-91">
              o que "no pasó así"…
            </p>
          </div>

          <p data-id="element-92">Por eso se creó este libro.</p>

          <p data-id="element-93">No para pelear en redes. No para ganar debates.</p>

          <p className="text-xl sm:text-2xl font-serif text-white text-center py-4 sm:py-8" data-id="element-94">
            Sino para dejar algo que nadie pueda borrar: <br data-id="element-95" />
            <span className="text-[#FFCC00]" data-id="element-96">memoria</span>,{' '}
            <span className="text-[#00247D]" data-id="element-97">registro</span> y{' '}
            <span className="text-[#CF142B]" data-id="element-98">verdad</span>.
          </p>
        </motion.div>
      </div>
    </section>;
}